import axios from 'axios'
import merge from 'lodash.merge'

import { AutoExpirationStorage, DAY } from '@shared/utils/storage'
import { preloaderService } from '@shared/services/preloader'
import { langifyUrl } from '@shared/utils/functions'

export const userStorage = new AutoExpirationStorage({
  prefix: `user-data-${window.$currentLanguage}`,
  backend: window.localStorage,
  expiration: DAY,
})
export const USER_KEY = '#prikorm-user-data'
export const USER_URL = langifyUrl('/api/session/')

export default {
  namespaced: true,

  state: {
    user: {},
  },

  mutations: {
    SET(state, data) {
      state.user = data

      userStorage.setItem(USER_KEY, state.user)
    },

    UPDATE(state, data) {
      state.user = merge({}, state.user, data)

      userStorage.setItem(USER_KEY, state.user)
    },

    CLEAR(state, data) {
      userStorage.clean()

      state.user = {}
    },
  },

  getters: {
    isAuthenticated(state) {
      return !!state.user.id
    }
  },

  actions: {
    INIT({ dispatch, commit, state }) {
      let localUser = userStorage.getItem(USER_KEY)

      if (localUser && localUser.user) {
        commit('SET', localUser)
      }

      dispatch('RETREIVE')
    },

    RETREIVE({ dispatch, commit, state }) {
      preloaderService.setLoading()

      return dispatch('SESSION')
        .then(session => {
          preloaderService.unsetLoading()
          commit('SET', session)
        })
    },

    SESSION({ dispatch, commit, state }) {
      let resource = axios.get(USER_URL)

      return resource.then(response => {
        return response.data.data
      }).catch(error => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/shared/store/modules/user.js